export const backendHostName = process.env.NEXT_PUBLIC_BACKEND_HOSTNAME as unknown as string;
export const googleAnalytics4Id = process.env
  .NEXT_PUBLIC_GOOGLE_ANALYTICS_4_ID as unknown as string;
